import {Component, constant, store} from 'Generic';
import {TEAMS} from 'Generic/constants/common';
import {
  getCurrentPrice,
  numberFormat,
  addCurrencySymbol,
  calculateTotalOldPrice,
  calculateDiscountedAmountAndPercentage,
  getTranslation,
} from 'Generic/lib';

export default class PlanBoxes extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('.cart-boxes-wrapper'),
      state: store.state,
    });
  }

  render() {
    const instance = this;
    const mainCartBox = document.querySelectorAll('.pro-cart-container .plan-box-wrapper');
    const grp_by_billing_cycle = [];
    const selectedCurrency = cartState.currency_code;

    let planCount = 0;

    for (let plan in cartState.plans) {
      const billingCycle = cartState.plans[plan].billing_cycle.toLowerCase();
      if (!grp_by_billing_cycle[billingCycle]) {
        grp_by_billing_cycle[billingCycle] = [];
      }
      grp_by_billing_cycle[billingCycle].push(cartState.plans[plan]);
    }

    let count = 0;

    for (let grp in grp_by_billing_cycle) {
      const dataBillingCycle = mainCartBox[count].getAttribute('data-billing-cycle');
      const plusCartBox = mainCartBox[count].querySelectorAll('.cart-box');

      plusCartBox.forEach(function (value, key) {
        const plan = grp_by_billing_cycle[dataBillingCycle][key];
        const selectedPlan = plan;

        const sumRequiredAddonPrice = calculateTotalOldPrice(1, cartState.old_prices, selectedCurrency, selectedPlan);
        const planPricePerMonth = selectedPlan?.per_month;

        // cut price placeholders
        const proCartCutPricee = value.querySelector('.pro-cart-box-month-div .pro-dt-ppl');
        if (proCartCutPricee) {
          proCartCutPricee.innerHTML = planPricePerMonth < sumRequiredAddonPrice ? `${addCurrencySymbol(numberFormat(sumRequiredAddonPrice))}` : '';
        }

        const moneyBackLabel = value.querySelector('.money-back-label');
        if (moneyBackLabel) {
          const planLabel = selectedPlan?.labels['money_back_label'] || plan?.labels['money_back_label'];
          moneyBackLabel.innerHTML = `${planLabel.replace(/\(price\)/g, instance.getCurrentPriceOnly(selectedPlan))}`;
          moneyBackLabel.innerHTML = moneyBackLabel.innerHTML.replace(/\(discounted-price\)/g, getCurrentPrice(selectedPlan));
          moneyBackLabel.innerHTML = moneyBackLabel.innerHTML.replace(
            /\(month-price\)/g,
            `${selectedPlan.per_month}${cartState.currencies_symbol[selectedCurrency]}`,
          );
        }

        const proCartBoxText = value.querySelector('.pro-cart-box-btm-text p');
        if (proCartBoxText) {
          const planLabel = selectedPlan?.labels['fpdr_text_label'] || plan?.labels['fpdr_text_label'];
          proCartBoxText.innerHTML = planLabel.replace(/\(price\)/g, instance.getCurrentPriceOnly(selectedPlan));
          proCartBoxText.innerHTML = proCartBoxText.innerHTML.replace(/\(discounted-price\)/g, getCurrentPrice(selectedPlan));
          proCartBoxText.innerHTML = proCartBoxText.innerHTML.replace(
            /\(month-price\)/g,
            `${selectedPlan?.per_month}${cartState.currencies_symbol[selectedCurrency]}`,
          );
        }

        planCount++;
      });

      count++;
    }

    // Teams plan toggle functionality
    const selectedPlan = cartState?.selected_plan;

    if (JSON.parse(selectedPlan?.description || '{}').plan_group === TEAMS) {
      const currencyCode = this.state.currency_code || 'USD';
      const currencySymbol = this.state.currencies_symbol[currencyCode] || '$';

      const {PURE_VPN} = constant;
      const teamsPlanTable = document.querySelector('.pro-cart-wrapper .teams-plan-table');

      if (teamsPlanTable) {
        const {addons, interval_length, labels = {}, months: planMonths} = selectedPlan;
        const months = parseInt(this.state.count_extra_month) === 1 ? planMonths : interval_length;
        const monthlyOldPrices = this.state.old_prices || {};
        const oldPrice = calculateTotalOldPrice(months, monthlyOldPrices, currencyCode, selectedPlan);

        const purevpnAddon = addons.find(addon => addon.code === PURE_VPN);
        const teamsPrice = Number(purevpnAddon?.unit_amount);

        const [discountPercentage, discountAmount] = calculateDiscountedAmountAndPercentage(Number(oldPrice), teamsPrice);
        const teamsPricePerMonth = teamsPrice / months;
        const oldPricePerMonth = oldPrice / months;

        const {per_month_label, price_package_plan_mobile_label, discount_label} = labels;

        // Update per-month price
        const perMonthPriceTarget = teamsPlanTable.querySelectorAll('.pro-cart-box-price p');
        perMonthPriceTarget.forEach(elem => {
          elem.innerHTML = `
              <sup class="cur-symbol">${currencySymbol}</sup>
              ${numberFormat(teamsPricePerMonth)}
              <span class="pro-per-month desktop">${per_month_label}</span>
              <span class="pro-per-month mobile">${price_package_plan_mobile_label}</span>
            `;
        });

        // Update old price if applicable
        const oldPriceTarget = teamsPlanTable.querySelectorAll('.pro-cart-box-month-div .pro-dt-ppl');
        oldPriceTarget.forEach(elem => {
          elem.innerHTML = oldPricePerMonth > teamsPricePerMonth ? addCurrencySymbol(numberFormat(oldPricePerMonth)) : '';
        });

        // Update discount
        const discountTarget = teamsPlanTable.querySelectorAll('.pro-cart-discount');
        discountTarget.forEach(elem => {
          elem.innerHTML =
            discountPercentage > 1
              ? `<span class='discount-price'>${discountPercentage}% ${getTranslation('off_small')}</span>`
              : `<span class='discount-price'>${discount_label}</span>`;
        });
      }
    }
  }

  //get current price only
  getCurrentPriceOnly(plan) {
    return plan.unit_amount + cartState.currencies_symbol[cartState.currency_code];
  }
}
